import {API_ROOT_URL} from 'envs/_current/config'
import {createTransform} from './utils/createTransform'
import {createListTransform} from './utils/createListTransform'
import {schema} from 'normalizr'

// ─── Schemas ──────────────────────────────────────────────────────────────────

export const prayerMethodSchema = new schema.Entity(
    'prayer_methods',
    {},
    {idAttribute: 'idname'}
)

export const prayerMethodStepSchema = new schema.Entity(
    'prayer_method_steps',
    {},
    {idAttribute: 'id'}
)

export const scriptureContentSchema = new schema.Entity(
    'scripture_contents',
    {},
    {idAttribute: 'id'}
)

export const journalEntrySchema = new schema.Entity(
    'journal_entries',
    {},
    {idAttribute: 'id'}
)

// ─── PrayerMethod Methods ───────────────────────────────────────────────────────────

export const prayerMethod_fetch_Api = {
    backend: `// Route::get('prayer-methods/fetch', 'PrayerMethodController@index')`,
    root: API_ROOT_URL,
    path: '/prayer-methods/fetch',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    paramsFields: ['language', 'keyword'],
    schema: prayerMethodSchema,
    transform: createListTransform(prayerMethodSchema),
}

export const prayerMethod_get_Api = {
    backend: `// Route::get('prayer-methods/{id}/get', 'PrayerMethodController@show')`,
    root: API_ROOT_URL,
    path: '/prayer-methods/:id/get',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    schema: prayerMethodSchema,
    transform: createTransform(prayerMethodSchema, 'data'),
}

export const prayerMethod_create_Api = {
    backend: `// Route::post('prayer-methods/create', 'PrayerMethodController@store')`,
    root: API_ROOT_URL,
    path: '/prayer-methods/create',
    method: 'POST',
    fields: ['name', 'idname', 'language', 'description', 'sort_order'],
    fieldTypes: {},
    schema: prayerMethodSchema,
    transform: createTransform(prayerMethodSchema, 'data'),
}

export const prayerMethod_edit_Api = {
    backend: `// Route::post('prayer-methods/{id}/edit', 'PrayerMethodController@update')`,
    root: API_ROOT_URL,
    path: '/prayer-methods/:id/edit',
    method: 'POST',
    fields: ['name', 'idname', 'language', 'description', 'is_active', 'sort_order'],
    fieldTypes: {},
    schema: prayerMethodSchema,
    transform: createTransform(prayerMethodSchema, 'data'),
}

export const prayerMethod_delete_Api = {
    backend: `// Route::post('prayer-methods/{id}/delete', 'PrayerMethodController@destroy')`,
    root: API_ROOT_URL,
    path: '/prayer-methods/:id/delete',
    method: 'POST',
    fields: [],
    fieldTypes: {},
    schema: prayerMethodSchema,
    transform: createTransform(prayerMethodSchema, 'data'),
}

// ─── Scripture Contents ───────────────────────────────────────────────────────

export const scriptureContent_fetch_Api = {
    backend: `// Route::get('scripture-contents/fetch', 'ScriptureContentController@index')`,
    root: API_ROOT_URL,
    path: '/scripture-contents/fetch',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    paramsFields: ['usage_type', 'keyword'],
    schema: scriptureContentSchema,
    transform: createListTransform(scriptureContentSchema),
}

export const scriptureContent_get_Api = {
    backend: `// Route::get('scripture-contents/{id}/get', 'ScriptureContentController@show')`,
    root: API_ROOT_URL,
    path: '/scripture-contents/:id/get',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    schema: scriptureContentSchema,
    transform: createTransform(scriptureContentSchema, 'data'),
}

export const scriptureContent_create_Api = {
    backend: `// Route::post('scripture-contents/create', 'ScriptureContentController@store')`,
    root: API_ROOT_URL,
    path: '/scripture-contents/create',
    method: 'POST',
    fields: ['scripture_ref', 'scripture_title', 'scripture_text', 'usage_type'],
    fieldTypes: {},
    schema: scriptureContentSchema,
    transform: createTransform(scriptureContentSchema, 'data'),
}

export const scriptureContent_edit_Api = {
    backend: `// Route::post('scripture-contents/{id}/edit', 'ScriptureContentController@update')`,
    root: API_ROOT_URL,
    path: '/scripture-contents/:id/edit',
    method: 'POST',
    fields: ['scripture_ref', 'scripture_title', 'scripture_text', 'usage_type', 'is_active'],
    fieldTypes: {},
    schema: scriptureContentSchema,
    transform: createTransform(scriptureContentSchema, 'data'),
}

export const scriptureContent_delete_Api = {
    backend: `// Route::post('scripture-contents/{id}/delete', 'ScriptureContentController@destroy')`,
    root: API_ROOT_URL,
    path: '/scripture-contents/:id/delete',
    method: 'POST',
    fields: [],
    fieldTypes: {},
    schema: scriptureContentSchema,
    transform: createTransform(scriptureContentSchema, 'data'),
}

// ─── Journal Entries ──────────────────────────────────────────────────────────

export const journalEntry_fetch_Api = {
    backend: `// Route::get('journal-entries/fetch', 'JournalEntryController@index')`,
    root: API_ROOT_URL,
    path: '/journal-entries/fetch',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    paramsFields: ['date', 'month', 'year', 'method_id', 'mood'],
    schema: journalEntrySchema,
    transform: createListTransform(journalEntrySchema),
}

export const journalEntry_byDay_Api = {
    backend: `// Route::get('journal-entries/by-day/{date}', 'JournalEntryController@byDay')`,
    root: API_ROOT_URL,
    path: '/journal-entries/by-day/:date',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    schema: journalEntrySchema,
    transform: createListTransform(journalEntrySchema),
}

export const journalEntry_myStats_Api = {
    backend: `// Route::get('journal-entries/my-stats', 'JournalEntryController@myStats')`,
    root: API_ROOT_URL,
    path: '/journal-entries/my-stats',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    schema: journalEntrySchema,
    transform: createListTransform(journalEntrySchema),
}

export const journalEntry_get_Api = {
    backend: `// Route::get('journal-entries/{id}/get', 'JournalEntryController@show')`,
    root: API_ROOT_URL,
    path: '/journal-entries/:id/get',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    schema: journalEntrySchema,
    transform: createTransform(journalEntrySchema, 'data'),
}

export const journalEntry_create_Api = {
    backend: `// Route::post('journal-entries/create', 'JournalEntryController@store')`,
    root: API_ROOT_URL,
    path: '/journal-entries/create',
    method: 'POST',
    fields: [
        'entry_date', 'method_id',
        'practice_session_id',
        'title',
        'started_at', 'completed_at',
        'scripture_ref', 'scripture_title', 'scripture_text',
        'steps_log',
        'final_mood', 'content',
    ],
    fieldTypes: {},
    schema: journalEntrySchema,
    transform: createTransform(journalEntrySchema, 'data'),
}

export const journalEntry_edit_Api = {
    backend: `// Route::post('journal-entries/{id}/edit', 'JournalEntryController@update')`,
    root: API_ROOT_URL,
    path: '/journal-entries/:id/edit',
    method: 'POST',
    fields: [
        'title',
        'started_at', 'completed_at',
        'scripture_ref', 'scripture_title', 'scripture_text',
        'steps_log',
        'final_mood', 'content',
    ],
    fieldTypes: {},
    schema: journalEntrySchema,
    transform: createTransform(journalEntrySchema, 'data'),
}

export const journalEntry_delete_Api = {
    backend: `// Route::post('journal-entries/{id}/delete', 'JournalEntryController@destroy')`,
    root: API_ROOT_URL,
    path: '/journal-entries/:id/delete',
    method: 'POST',
    fields: [],
    fieldTypes: {},
    schema: journalEntrySchema,
    transform: createTransform(journalEntrySchema, 'data'),
}
